import { render } from "./AddExtraTimeToBooking.vue?vue&type=template&id=3cb1a78b"
import script from "./AddExtraTimeToBooking.vue?vue&type=script&lang=js"
export * from "./AddExtraTimeToBooking.vue?vue&type=script&lang=js"
script.render = render

export default script